import {Text, TextStyle} from "pixi.js";
import {CANVAS, REEL} from "../constants/configs";
import {gsap} from "gsap";
import {getAmountWithCurrency} from "../utilites";
import {getStores} from "./spin";
export class ExplodeWinAmount {

    pixiText = new Text("150.00 FUN", textStyle);

    constructor() {
        this.pixiText.anchor.set(0.5);
        this.pixiText.alpha = 0;
    }

    highlight(x, y, amount) {
        this.pixiText.alpha = 1;
        this.pixiText.position.set(x, y);
        this.pixiText.text = getAmountWithCurrency(amount, getStores().store.currency);
        gsap.to(this.pixiText.position, {duration: 0.8, y: this.pixiText.position.y - REEL.height/REEL.symbolsCount});
        gsap.to(this.pixiText, {duration: 0.8, alpha: 0, ease: "bounce.in"});
    }

}

const textStyle = new TextStyle({
    fontFamily: 'BebasNeue',
    fontWeight: 500,
    fill: ['#ffffff', '#d2d2d2'],
    dropShadow: true,
    dropShadowColor: 'rgba(0,0,0,0.68)',
    dropShadowBlur: 5,
    dropShadowAngle: Math.PI / 4,
    dropShadowDistance: 2,
    fontSize: 55,
    wordWrapWidth: CANVAS.width * 1.8,
    align: 'center',
});